export default __webpack_public_path__ + "static/media/link_circle.45545a59.svg";